<mat-card>
  <mat-card-content>
    <div class="text-center">
      <img alt="homepage" src="assets/images/logo-icon.png" />
      <h4 class="m-t-0">Register to GIZ</h4>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Nombres</mat-label>
        <input
          matInput
          placeholder="John"
          [formControl]="username"
          type="text"
          autocomplete="off"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Apellidos</mat-label>
        <input
          matInput
          placeholder="Doe"
          [formControl]="username"
          type="text"
          autocomplete="off"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>País</mat-label>
        <input
          matInput
          placeholder="Peru"
          [formControl]="username"
          type="text"
          autocomplete="off"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Correo electronico</mat-label>
        <input
          matInput
          placeholder="john@mail.com"
          [formControl]="username"
          type="email"
          autocomplete="off"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Apodo</mat-label>
        <input
          matInput
          placeholder="jdoe2022"
          [formControl]="username"
          type="text"
          autocomplete="off"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Contraseña</mat-label>
        <input
          matInput
          [formControl]="password_a"
          [type]="hide ? 'password' : 'text'"
          autocomplete="off"
          required
        />
        <button mat-icon-button matSuffix (click)="hide = !hide">
          <mat-icon> {{ hide ? "visibility_off" : "visibility" }}</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Confirmar contraseña</mat-label>
        <input
          matInput
          [formControl]="password_b"
          [type]="hide ? 'password' : 'text'"
          autocomplete="off"
          required
        />
        <button mat-icon-button matSuffix (click)="hide = !hide">
          <mat-icon> {{ hide ? "visibility_off" : "visibility" }}</mat-icon>
        </button>
      </mat-form-field>

      <div class="actions">
        <button
          fxFlex="100"
          mat-raised-button
          color="primary"
          (click)="signUp()"
          [disabled]="!username.valid || !password_a.valid || !password_b.valid"
        >
          Crear cuenta
        </button>
      </div>

      <div class="actions align-text-center">
        <mat-label>¿Ya tienes una cuenta?</mat-label>
        <button mat-button color="primary" (click)="goSignIn()">
          Iniciar sesion
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
